(function () {
  'use strict';
  var initialized = new WeakSet();
  function parseList(value) { try { var parsed = JSON.parse(value || '[]'); return Array.isArray(parsed) ? parsed : []; } catch (_) { return []; } }
  function activeColor(root, variant) {
    var position = Number(root.dataset.colorPosition || 0);
    return variant && Array.isArray(variant.options) && position > 0 ? String(variant.options[position - 1] || '') : String(root.dataset.activeColor || '');
  }
  function eligible(record, color) {
    var scope = record.dataset.scope;
    if (scope === 'all_colors') return true;
    if (!color) return false;
    var included = parseList(record.dataset.included);
    var excluded = parseList(record.dataset.excluded);
    return scope === 'include_only' ? included.includes(color) : scope === 'exclude_only' ? !excluded.includes(color) : false;
  }
  function render(root, color, announce) {
    var families = new Set();
    var records = Array.from(root.querySelectorAll('[data-highlight-records] > [data-highlight-record]')).filter(function (record) {
      if (!eligible(record, color) || families.has(record.dataset.family)) return false;
      families.add(record.dataset.family); return true;
    }).slice(0, 3);
    if (records.length < 2) { root.hidden = true; return; }
    var target = root.querySelector('[data-highlight-visible]');
    target.replaceChildren.apply(target, records.map(function (record) { return record.cloneNode(true); }));
    var sensitive = records.some(function (record) { return record.dataset.scope !== 'all_colors'; });
    var context = root.querySelector('[data-highlight-color-context]');
    context.textContent = sensitive && color ? 'For ' + color : '';
    root.hidden = false;
    if (announce && color) root.querySelector('[data-highlight-status]').textContent = 'Garment highlights updated for ' + color + '.';
    var signature = color + '|' + Array.from(families).join(',');
    if (root.dataset.metricSignature !== signature) {
      root.dataset.metricSignature = signature;
      window.PrintmoProductPageMetrics?.emit('garment_highlights_rendered', { product_handle: root.dataset.productHandle, highlight_count: records.length, color_sensitive: sensitive, families: Array.from(families).join(',') });
    }
  }
  function init(root) {
    if (initialized.has(root)) return; initialized.add(root);
    var product = root.closest('product-info'); var pending = false;
    render(root, activeColor(root), false);
    if (typeof window.subscribe === 'function' && window.theme?.PUB_SUB_EVENTS) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.optionValueSelectionChange, function (payload) { if (!product?.contains(payload?.data?.event?.target)) return; pending = true; root.hidden = true; });
      window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function (payload) { if (String(payload?.data?.sectionId) !== String(product?.dataset?.section)) return; render(root, activeColor(root, payload?.data?.variant), pending); pending = false; });
    }
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-garment-highlights]').forEach(init); }
  document.addEventListener('theme:product-info:loaded', function (event) { boot(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }); else boot(document);
})();
